import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IMinPay {
  YEAR: string;
  MINPAY: string;
}

export interface IMinPayState {
  minPays: IMinPay[];
  setMinPays: (wages: IMinPay[]) => void;
  getMinPayByYear: (year: string) => string | undefined;
  resetMinPays: () => void;
}

export const useMinPayStore = create<IMinPayState>()(
  persist(
    (set, get) => ({
      minPays: [],
      setMinPays: (wages: IMinPay[]) =>
        set(() => ({
          minPays: wages,
        })),
      getMinPayByYear: (year: string) => {
        const wage = get().minPays.find((w) => w.YEAR === year);
        return wage?.MINPAY;
      },
      resetMinPays: () =>
        set(() => ({
          minPays: [],
        })),
    }),
    {
      name: 'minimum-wage-storage',
      storage: {
        getItem: (name) => {
          const str = sessionStorage.getItem(name);
          return str ? JSON.parse(str) : null;
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => sessionStorage.removeItem(name),
      },
      onRehydrateStorage: (state) => {
        return (state, error) => {
          if (error) {
            console.error('최저시급 데이터 로드 실패:', error);
          }
        };
      },
    },
  ),
);

export default useMinPayStore;
